var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuperCoins = function SvgSuperCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.25C6.11621 25.25 0.75 19.9353 0.75 13.1583C0.75 6.30871 6.25484 0.75 13 0.75C19.7451 0.75 25.25 6.30872 25.25 13.1583C25.25 19.9353 19.8838 25.25 13 25.25Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0674 4L7.48502 12.3858C6.50828 13.4661 7.08314 14.9907 8.52829 14.953L12.9036 14.9935C13.1245 14.9935 13.3029 15.1766 13.3002 15.4002C13.3002 15.4352 13.2949 15.4702 13.2869 15.5052L11.5304 22L19.0515 13.7462C19.9937 12.7118 19.2697 11.0362 17.8778 11.0362L13.561 11.1171C13.3401 11.1225 13.1591 10.9446 13.1538 10.7211C13.1538 10.6806 13.1591 10.6402 13.1697 10.5998C13.6302 8.96199 15.0088 4.05926 15.0674 4Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuperCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SuperCoins.ba054869.svg";
export { ForwardRef as ReactComponent };